import url from 'url';
import 'whatwg-fetch';
import {SpecValidator} from 'api-spec';

const spec_validator = new SpecValidator({
  resolver: async uri => {
    const parsed = url.parse(uri);
    const outbound = url.format({
      hostname: parsed.hostname,
      port: window.location.port,
      protocol: parsed.protocol,
      pathname: parsed.path
    });
    const response = await fetch(outbound);
    const schema = await response.json();
    //console.log(outbound, schema.id);
    return schema;
  }
});

const validate = spec => spec_validator.validate(spec);
const get_tags = spec => spec_validator.get_tags(spec);
const compile = schema => spec_validator.compile(spec);
const resolve_refs = spec => spec_validator.resolve_refs(spec);
const strip_props = (...args) => spec_validator.strip_props(...args);

export {
  validate,
  get_tags,
  spec_validator,
  resolve_refs,
  strip_props
};
